import { EventBus } from '@/lib/event-bus';

export default function useOverlaySpinner() {
  const show = (text = '') => {
    EventBus.$emit('show-overlay-spinner', { text });
  };

  const hide = () => {
    EventBus.$emit('hide-overlay-spinner');
  };

  return {
    showOverlaySpinner: show,
    hideOverlaySpinner: hide,
  };
}
